export const SOCIAL_MESSAGE = 'SocialMessage';
export const STORYLET_MESSAGE = 'StoryletMessage';
export const INVITATION_FROM_YOU = 'InvitationFromYou';
export const INVITATION_TO_YOU = 'InvitationToYou';